/**
 * 网站语言工具：localStorage(site_lang) + 字段级双语取值 + UI 静态文案字典。
 * 数据字段命名约定：中文字段为基名（name），英文字段为基名 + En（nameEn）。
 * 英文为空时回退中文。
 */

import UI_STRINGS from '../i18n/ui'

const LANG_KEY = 'site_lang'

export function getLang() {
  return localStorage.getItem(LANG_KEY) || 'zh'
}

export function setLang(lang) {
  localStorage.setItem(LANG_KEY, lang)
}

/** 切换语言并整页刷新（Vue2 不做全局响应式重构） */
export function switchLang(lang) {
  if (getLang() === lang) return
  setLang(lang)
  window.location.reload()
}

/**
 * 取字段的双语值：tf(product, 'name') → lang=zh 取 product.name，lang=en 优先 product.nameEn
 */
export function tf(obj, base) {
  if (!obj) return ''
  if (getLang() === 'en') {
    const en = obj[base + 'En']
    if (en !== null && en !== undefined && en !== '') return en
  }
  const val = obj[base]
  return val === null || val === undefined ? '' : val
}

/**
 * 取 [{zh, en}] 结构的当前语言值
 */
export function tfList(item) {
  if (!item) return ''
  if (getLang() === 'en' && item.en) return item.en
  return item.zh || item.en || ''
}

/**
 * 取"另一语言"的值（用于中英并列 eyebrow 装饰）：zh 时取英文（回退中文），en 时取中文（回退英文）。
 * 例外：英文模式下另一语言值含汉字时不返回（英文站不得出现中文），返回空串由调用处隐藏。
 */
export function tfAlt(obj, base) {
  if (!obj) return ''
  if (getLang() === 'zh') {
    const en = obj[base + 'En']
    if (en) return en
  }
  const val = obj[base]
  if (getLang() === 'en') {
    if (val && /[一-鿿]/.test(val)) return ''
    return val || obj[base + 'En'] || ''
  }
  if (val) return val
  return obj[base + 'En'] || ''
}

/** Vue mixin：注入 lang / tf / tfList */
export const langMixin = {
  data() {
    return { lang: getLang() }
  },
  methods: { tf, tfAlt, tfList, t, articleTypeLabel }
}

/**
 * UI 静态文案取值：t('nav.products')，缺失回退中文，再回退 key 本身。
 * 支持插值：t('product.enquiryTitle', { name: 'LUX' })
 */
export function t(key, vars) {
  const lang = getLang()
  let val = (UI_STRINGS[lang] && UI_STRINGS[lang][key]) || UI_STRINGS.zh[key]
  if (val === undefined || val === null || val === '') val = key
  if (vars) {
    val = val.replace(/\{(\w+)\}/g, (m, name) => (vars[name] !== undefined ? vars[name] : m))
  }
  return val
}

/** 文章类型标签：insight → 洞察/Insight，其余 → 新闻/News */
export function articleTypeLabel(type) {
  return type === 'insight' ? t('common.insight') : t('common.news')
}
